// AUTO-GENERATED FILE. DO NOT EDIT.
// Generated from role_schema.json

export const ADMIN_PORTAL_REGIONS_FILES_READ = 'admin_portal_regions_files_read';
export const ADMIN_PORTAL_REGIONS_FILES_UPDATE = 'admin_portal_regions_files_update';
export const ADMIN_PRODUCT_UPDATE_CREATE = 'admin_product_update_create';
export const ADMIN_PRODUCT_UPDATE_DELETE = 'admin_product_update_delete';
export const ADMIN_PRODUCT_UPDATE_UPDATE = 'admin_product_update_update';
export const AGENT_ALLOCATION_SUMMARY_SHOW = 'agent_allocation_summary_show';
export const AGENT_APPOINTMENT_CANCEL = 'agent_appointment_cancel';
export const AGENT_APPOINTMENT_EVALUATE = 'agent_appointment_evaluate';
export const AGENT_BILLING_CHARGES_READ = 'agent_billing_charges_read';
export const AGENT_BILLING_COST_ESTIMATES_READ = 'agent_billing_cost_estimates_read';
export const AGENT_COMP_REQUEST_EVALUATE = 'agent_comp_request_evaluate';
export const AGENT_COMP_REQUEST_UPDATE = 'agent_comp_request_update';
export const AGENT_INSURANCE_PAYER_LOOKUP = 'agent_insurance_payer_lookup';
export const AGENT_PROVIDER_PAY_INVOICE_READ = 'agent_provider_pay_invoice_read';
export const APERO_INVOICE_CREATE = 'apero_invoice_create';
export const APERO_INVOICE_GENERATION_JOB_CREATE = 'apero_invoice_generation_job_create';
export const APERO_READ = 'apero_read';
export const APERO_UPDATE = 'apero_update';
export const APPOINTMENT_ALLOCATION_ADDON_CREATE = 'appointment_allocation_addon_create';
export const APPOINTMENT_ALLOCATION_ADDON_DELETE = 'appointment_allocation_addon_delete';
export const APPOINTMENT_ALLOCATION_ADDON_READ = 'appointment_allocation_addon_read';
export const APPOINTMENT_ALLOCATION_ADDON_UPDATE = 'appointment_allocation_addon_update';
export const APPOINTMENT_ALLOCATION_ADDONS_READ = 'appointment_allocation_addons_read';
export const APPOINTMENT_ALLOCATION_CREATE = 'appointment_allocation_create';
export const APPOINTMENT_ALLOCATION_DELETE = 'appointment_allocation_delete';
export const APPOINTMENT_ALLOCATION_READ = 'appointment_allocation_read';
export const APPOINTMENT_ALLOCATION_UPDATE = 'appointment_allocation_update';
export const APPOINTMENT_ALLOCATIONS_OFFSHORE_READ = 'appointment_allocations_offshore_read';
export const APPOINTMENT_ALLOCATIONS_READ = 'appointment_allocations_read';
export const APPOINTMENT_CATEGORY_ALLOCATIONS_OFFSHORE_READ = 'appointment_category_allocations_offshore_read';
export const APPOINTMENT_CATEGORY_ALLOCATIONS_READ = 'appointment_category_allocations_read';
export const APPOINTMENT_CREATE = 'appointment_create';
export const APPOINTMENT_OFFSHORE_CREATE = 'appointment_offshore_create';
export const APPOINTMENT_OFFSHORE_READ = 'appointment_offshore_read';
export const APPOINTMENT_OFFSHORE_UPDATE = 'appointment_offshore_update';
export const APPOINTMENT_PAST_CREATE = 'appointment_past_create';
export const APPOINTMENT_READ = 'appointment_read';
export const APPOINTMENT_UPDATE = 'appointment_update';
export const APPOINTMENTS_OFFSHORE_READ = 'appointments_offshore_read';
export const APPOINTMENTS_READ = 'appointments_read';
export const ASSESSMENT_CREATE = 'assessment_create';
export const ASSESSMENT_OFFSHORE_CREATE = 'assessment_offshore_create';
export const ASSESSMENT_OFFSHORE_READ = 'assessment_offshore_read';
export const ASSESSMENT_OFFSHORE_UPDATE = 'assessment_offshore_update';
export const ASSESSMENT_READ = 'assessment_read';
export const ASSESSMENT_REPORT_READ = 'assessment_report_read';
export const ASSESSMENT_TRIAGE_UPDATE = 'assessment_triage_update';
export const ASSESSMENT_TRIAL_READ = 'assessment_trial_read';
export const ASSESSMENT_UPDATE = 'assessment_update';
export const ASSESSMENTS_OFFSHORE_READ = 'assessments_offshore_read';
export const ASSESSMENTS_READ = 'assessments_read';
export const ASSESSMENTS_TRIAL_READ = 'assessments_trial_read';
export const BENEFITS_PAGE_CONFIG_READ = 'benefits_page_config_read';
export const BENEFITS_PAGE_CONFIG_UPDATE = 'benefits_page_config_update';
export const BILLING_RULE_CREATE = 'billing_rule_create';
export const BILLING_RULE_READ = 'billing_rule_read';
export const BILLING_RULE_UPDATE = 'billing_rule_update';
export const BILLING_RULES_READ = 'billing_rules_read';
export const BLUE_CROSS_MEMBER_ID_PREFIX_CREATE = 'blue_cross_member_id_prefix_create';
export const BLUE_CROSS_MEMBER_ID_PREFIX_READ = 'blue_cross_member_id_prefix_read';
export const BLUE_CROSS_MEMBER_ID_PREFIX_UPDATE = 'blue_cross_member_id_prefix_update';
export const BLUE_CROSS_MEMBER_ID_PREFIXES_READ = 'blue_cross_member_id_prefixes_read';
export const BULK_CHARGE_RUN_CREATE = 'bulk_charge_run_create';
export const BULK_CHARGE_RUN_READ = 'bulk_charge_run_read';
export const BULK_CHARGE_RUNS_READ = 'bulk_charge_runs_read';
export const CARE_NAVIGATOR_CUSTOMER_ASSIGNMENT_OFFSHORE_READ = 'care_navigator_customer_assignment_offshore_read';
export const CARE_NAVIGATOR_CUSTOMER_ASSIGNMENT_READ = 'care_navigator_customer_assignment_read';
export const CARE_NAVIGATOR_CUSTOMER_ASSIGNMENTS_OFFSHORE_READ = 'care_navigator_customer_assignments_offshore_read';
export const CARE_NAVIGATOR_CUSTOMER_ASSIGNMENTS_READ = 'care_navigator_customer_assignments_read';
export const CARE_PLAN_PROGRESS_OFFSHORE_READ = 'care_plan_progress_offshore_read';
export const CARE_PLAN_PROGRESS_READ = 'care_plan_progress_read';
export const CARE_PLAN_PROGRESSES_OFFSHORE_READ = 'care_plan_progresses_offshore_read';
export const CARE_PLAN_PROGRESSES_READ = 'care_plan_progresses_read';
export const CARE_PROVIDER_CREATE = 'care_provider_create';
export const CARE_PROVIDER_READ = 'care_provider_read';
export const CARE_PROVIDER_RESTRICTED_DATA_READ = 'care_provider_restricted_data_read';
export const CARE_PROVIDER_TAG_READ = 'care_provider_tag_read';
export const CARE_PROVIDER_TAGS_READ = 'care_provider_tags_read';
export const CARE_PROVIDER_UPDATE = 'care_provider_update';
export const CARE_PROVIDERS_OFFSHORE_READ = 'care_providers_offshore_read';
export const CARE_PROVIDERS_READ = 'care_providers_read';
export const CENSUS_INGESTION_CREATE = 'census_ingestion_create';
export const CENSUS_INGESTION_OFFSHORE_READ = 'census_ingestion_offshore_read';
export const CENSUS_INGESTION_READ = 'census_ingestion_read';
export const CENSUS_INGESTION_ROW_OFFSHORE_READ = 'census_ingestion_row_offshore_read';
export const CENSUS_INGESTION_ROW_READ = 'census_ingestion_row_read';
export const CENSUS_INGESTION_ROWS_OFFSHORE_READ = 'census_ingestion_rows_offshore_read';
export const CENSUS_INGESTION_ROWS_READ = 'census_ingestion_rows_read';
export const CENSUS_INGESTIONS_OFFSHORE_READ = 'census_ingestions_offshore_read';
export const CENSUS_INGESTIONS_READ = 'census_ingestions_read';
export const CHANNEL_PARTNER_CREATE = 'channel_partner_create';
export const CHANNEL_PARTNER_OFFSHORE_READ = 'channel_partner_offshore_read';
export const CHANNEL_PARTNER_OFFSHORE_UPDATE = 'channel_partner_offshore_update';
export const CHANNEL_PARTNER_READ = 'channel_partner_read';
export const CHANNEL_PARTNER_UPDATE = 'channel_partner_update';
export const CHANNEL_PARTNERS_OFFSHORE_READ = 'channel_partners_offshore_read';
export const CHANNEL_PARTNERS_READ = 'channel_partners_read';
export const COHORT_CREATE = 'cohort_create';
export const COHORT_DEACTIVATION_CREATE = 'cohort_deactivation_create';
export const COHORT_DEACTIVATION_READ = 'cohort_deactivation_read';
export const COHORT_DEACTIVATION_UPDATE = 'cohort_deactivation_update';
export const COHORT_DEACTIVATIONS_READ = 'cohort_deactivations_read';
export const COHORT_EMAIL_CUSTOMIZATION_OFFSHORE_READ = 'cohort_email_customization_offshore_read';
export const COHORT_EMAIL_CUSTOMIZATION_READ = 'cohort_email_customization_read';
export const COHORT_EMAIL_CUSTOMIZATION_UPDATE = 'cohort_email_customization_update';
export const COHORT_EMAIL_CUSTOMIZATIONS_OFFSHORE_READ = 'cohort_email_customizations_offshore_read';
export const COHORT_EMAIL_CUSTOMIZATIONS_READ = 'cohort_email_customizations_read';
export const COHORT_IGNORE_CUSTOMER_AUTO_RELAUNCH_PLAN_YEARS_UPDATE =
  'cohort_ignore_customer_auto_relaunch_plan_years_update';
export const COHORT_MOVE_REQUEST_CREATE = 'cohort_move_request_create';
export const COHORT_MOVE_REQUEST_READ = 'cohort_move_request_read';
export const COHORT_MOVE_REQUEST_SAME_CUSTOMER_CREATE = 'cohort_move_request_same_customer_create';
export const COHORT_OFFSHORE_READ = 'cohort_offshore_read';
export const COHORT_PAYER_MAPPING_CREATE = 'cohort_payer_mapping_create';
export const COHORT_PAYER_MAPPING_DELETE = 'cohort_payer_mapping_delete';
export const COHORT_PAYER_MAPPING_READ = 'cohort_payer_mapping_read';
export const COHORT_PAYER_MAPPING_UPDATE = 'cohort_payer_mapping_update';
export const COHORT_PAYER_MAPPINGS_READ = 'cohort_payer_mappings_read';
export const COHORT_READ = 'cohort_read';
export const COHORT_TRIAL_UPDATE = 'cohort_trial_update';
export const COHORT_UPDATE = 'cohort_update';
export const COHORTS_LIST = 'cohorts_list';
export const COHORTS_OFFSHORE_READ = 'cohorts_offshore_read';
export const COHORTS_READ = 'cohorts_read';
export const COHORTS_SHOW = 'cohorts_show';
export const CONNECTED_BENEFIT_CREATE = 'connected_benefit_create';
export const CONNECTED_BENEFIT_DELETE = 'connected_benefit_delete';
export const CONNECTED_BENEFIT_READ = 'connected_benefit_read';
export const CONNECTED_BENEFIT_UPDATE = 'connected_benefit_update';
export const CONNECTED_BENEFITS_READ = 'connected_benefits_read';
export const CONTRACT_TERM_CONTENT_UPDATE = 'contract_term_content_update';
export const CONTRACT_TERM_CREATE = 'contract_term_create';
export const CONTRACT_TERM_DELETE = 'contract_term_delete';
export const CONTRACT_TERM_OFFSHORE_READ = 'contract_term_offshore_read';
export const CONTRACT_TERM_READ = 'contract_term_read';
export const CONTRACT_TERM_TRIAL_UPDATE = 'contract_term_trial_update';
export const CONTRACT_TERM_UPDATE = 'contract_term_update';
export const CONTRACT_TERMS_LIST = 'contract_terms_list';
export const CONTRACT_TERMS_OFFSHORE_READ = 'contract_terms_offshore_read';
export const CONTRACT_TERMS_READ = 'contract_terms_read';
export const CONTRACT_TERMS_SHOW = 'contract_terms_show';
export const COVERED_LIFE_CREATE = 'covered_life_create';
export const COVERED_LIFE_DEACTIVATION_OFFSHORE_READ = 'covered_life_deactivation_offshore_read';
export const COVERED_LIFE_DEACTIVATION_READ = 'covered_life_deactivation_read';
export const COVERED_LIFE_DEACTIVATIONS_OFFSHORE_READ = 'covered_life_deactivations_offshore_read';
export const COVERED_LIFE_DEACTIVATIONS_READ = 'covered_life_deactivations_read';
export const COVERED_LIFE_OFFSHORE_CREATE = 'covered_life_offshore_create';
export const COVERED_LIFE_OFFSHORE_READ = 'covered_life_offshore_read';
export const COVERED_LIFE_OFFSHORE_SEND_REVERIFICATION = 'covered_life_offshore_send_reverification';
export const COVERED_LIFE_OFFSHORE_UPDATE = 'covered_life_offshore_update';
export const COVERED_LIFE_PRIMARY_OFFSHORE_UPDATE = 'covered_life_primary_offshore_update';
export const COVERED_LIFE_PRIMARY_UPDATE = 'covered_life_primary_update';
export const COVERED_LIFE_READ = 'covered_life_read';
export const COVERED_LIFE_SEND_INVITES = 'covered_life_send_invites';
export const COVERED_LIFE_SEND_REVERIFICATION = 'covered_life_send_reverification';
export const COVERED_LIFE_SOFT_DELETE = 'covered_life_soft_delete';
export const COVERED_LIFE_UPDATE = 'covered_life_update';
export const COVERED_LIFE_VERIFICATION_HISTORY_READ = 'covered_life_verification_history_read';
export const COVERED_LIVES_LIST = 'covered_lives_list';
export const COVERED_LIVES_OFFSHORE_READ = 'covered_lives_offshore_read';
export const COVERED_LIVES_READ = 'covered_lives_read';
export const COVERED_LIVES_SHOW = 'covered_lives_show';
export const CUSTOMER_ADMIN_NOTES_CREATE = 'customer_admin_notes_create';
export const CUSTOMER_ADMIN_NOTES_OFFSHORE_UPDATE = 'customer_admin_notes_offshore_update';
export const CUSTOMER_ADMIN_NOTES_READ = 'customer_admin_notes_read';
export const CUSTOMER_ADMIN_NOTES_UPDATE = 'customer_admin_notes_update';
export const CUSTOMER_AUTO_RELAUNCH_PLAN_YEARS_UPDATE = 'customer_auto_relaunch_plan_years_update';
export const CUSTOMER_CONTENT_CONFIG_UPDATE = 'customer_content_config_update';
export const CUSTOMER_CREATE = 'customer_create';
export const CUSTOMER_CREATION_INGESTION_PROCESS_ROWS = 'customer_creation_ingestion_process_rows';
export const CUSTOMER_CREATION_INGESTION_READ = 'customer_creation_ingestion_read';
export const CUSTOMER_CREATION_INGESTION_ROW_READ = 'customer_creation_ingestion_row_read';
export const CUSTOMER_CREATION_INGESTION_ROW_REJECT = 'customer_creation_ingestion_row_reject';
export const CUSTOMER_CREATION_INGESTION_ROWS_READ = 'customer_creation_ingestion_rows_read';
export const CUSTOMER_CREATION_INGESTIONS_READ = 'customer_creation_ingestions_read';
export const CUSTOMER_DEACTIVATION_CREATE = 'customer_deactivation_create';
export const CUSTOMER_DEACTIVATION_OFFSHORE_READ = 'customer_deactivation_offshore_read';
export const CUSTOMER_DEACTIVATION_READ = 'customer_deactivation_read';
export const CUSTOMER_DEACTIVATION_UPDATE = 'customer_deactivation_update';
export const CUSTOMER_DEACTIVATIONS_LIST = 'customer_deactivations_list';
export const CUSTOMER_DEACTIVATIONS_OFFSHORE_READ = 'customer_deactivations_offshore_read';
export const CUSTOMER_DEACTIVATIONS_READ = 'customer_deactivations_read';
export const CUSTOMER_DEACTIVATIONS_SHOW = 'customer_deactivations_show';
export const CUSTOMER_EXTERNAL_ID_READ = 'customer_external_id_read';
export const CUSTOMER_EXTERNAL_ID_UPDATE = 'customer_external_id_update';
export const CUSTOMER_FEATURE_CONTROLS_READ = 'customer_feature_controls_read';
export const CUSTOMER_FEATURE_CONTROLS_UPDATE = 'customer_feature_controls_update';
export const CUSTOMER_INACTIVE_AT_IGNORE_GRACE_UPDATE = 'customer_inactive_at_ignore_grace_update';
export const CUSTOMER_OFFSHORE_READ = 'customer_offshore_read';
export const CUSTOMER_OFFSHORE_SUPPORT_ENABLED_UPDATE = 'customer_offshore_support_enabled_update';
export const CUSTOMER_RATE_CARD_OFFSHORE_READ = 'customer_rate_card_offshore_read';
export const CUSTOMER_RATE_CARD_READ = 'customer_rate_card_read';
export const CUSTOMER_RATE_CARD_SYNC = 'customer_rate_card_sync';
export const CUSTOMER_RATE_CARDS_OFFSHORE_READ = 'customer_rate_cards_offshore_read';
export const CUSTOMER_RATE_CARDS_READ = 'customer_rate_cards_read';
export const CUSTOMER_REACTIVATE_UPDATE = 'customer_reactivate_update';
export const CUSTOMER_READ = 'customer_read';
export const CUSTOMER_SITE_CREATE = 'customer_site_create';
export const CUSTOMER_SITE_OFFSHORE_READ = 'customer_site_offshore_read';
export const CUSTOMER_SITE_READ = 'customer_site_read';
export const CUSTOMER_SITE_UPDATE = 'customer_site_update';
export const CUSTOMER_SITES_LIST = 'customer_sites_list';
export const CUSTOMER_SITES_OFFSHORE_READ = 'customer_sites_offshore_read';
export const CUSTOMER_SITES_READ = 'customer_sites_read';
export const CUSTOMER_TRIAL_UPDATE = 'customer_trial_update';
export const CUSTOMER_UPDATE = 'customer_update';
export const CUSTOMERS_LIST = 'customers_list';
export const CUSTOMERS_OFFSHORE_READ = 'customers_offshore_read';
export const CUSTOMERS_READ = 'customers_read';
export const DEDICATED_PROVIDERS_READ = 'dedicated_providers_read';
export const DEMO_ACCOUNT_CREATE = 'demo_account_create';
export const DEMO_ACCOUNT_READ = 'demo_account_read';
export const DEMO_ACCOUNT_UPDATE = 'demo_account_update';
export const DEMO_ACCOUNTS_READ = 'demo_accounts_read';
export const ELIGIBILITY_CLAIM_MEMBER_COVERAGE = 'eligibility_claim_member_coverage';
export const ELIGIBILITY_COVERAGE_READ = 'eligibility_coverage_read';
export const ELIGIBILITY_COVERAGES_READ = 'eligibility_coverages_read';
export const ELIGIBILITY_MEMBERSHIP_DESTROY = 'eligibility_membership_destroy';
export const ELIGIBILITY_MEMBERSHIP_READ = 'eligibility_membership_read';
export const ELIGIBILITY_MEMBERSHIPS_READ = 'eligibility_memberships_read';
export const INSURANCE_PAYER_ENABLEMENT_CREATE = 'insurance_payer_enablement_create';
export const INSURANCE_PAYER_ENABLEMENTS_DESTROY = 'insurance_payer_enablements_destroy';
export const INSURANCE_PAYER_ENABLEMENTS_READ = 'insurance_payer_enablements_read';
export const INSURANCE_PAYER_ENABLEMENTS_UPDATE = 'insurance_payer_enablements_update';
export const INTEROPERABILITY_READ = 'interoperability_read';
export const INVOICE_GENERATION_LOGS_READ = 'invoice_generation_logs_read';
export const MAINTENANCE_TASKS_READ = 'maintenance_tasks_read';
export const MARKETPLACE_ENROLLMENT_READ = 'marketplace_enrollment_read';
export const MARKETPLACE_ENROLLMENT_UPDATE = 'marketplace_enrollment_update';
export const MEMBER_ALLOCATION_CALCULATION_RUN = 'member_allocation_calculation_run';
export const MEMBER_COMMUNICATION_READ = 'member_communication_read';
export const MEMBER_COMMUNICATION_UPDATE = 'member_communication_update';
export const MEMBER_DEACTIVATION_OFFSHORE_UPDATE = 'member_deactivation_offshore_update';
export const MEMBER_DEACTIVATION_READ = 'member_deactivation_read';
export const MEMBER_DEACTIVATION_UPDATE = 'member_deactivation_update';
export const MEMBER_GOAL_OFFSHORE_READ = 'member_goal_offshore_read';
export const MEMBER_GOALS_OFFSHORE_READ = 'member_goals_offshore_read';
export const MEMBER_OFFSHORE_READ = 'member_offshore_read';
export const MEMBER_OFFSHORE_UPDATE = 'member_offshore_update';
export const MEMBER_PRIMARY_DEPENDENT_CREATE = 'member_primary_dependent_create';
export const MEMBER_PRIMARY_DEPENDENT_DELETE = 'member_primary_dependent_delete';
export const MEMBER_PRIMARY_DEPENDENT_READ = 'member_primary_dependent_read';
export const MEMBER_PRIMARY_DEPENDENT_UPDATE = 'member_primary_dependent_update';
export const MEMBER_READ = 'member_read';
export const MEMBER_SPECIAL_INSTRUCTIONS_UPDATE = 'member_special_instructions_update';
export const MEMBER_TRIAL_UPDATE = 'member_trial_update';
export const MEMBER_UPDATE = 'member_update';
export const MEMBERS_OFFSHORE_READ = 'members_offshore_read';
export const MEMBERS_READ = 'members_read';
export const MHLA_FORM_REVIEW_UPDATE = 'mhla_form_review_update';
export const NON_CENSUS_COVERED_LIFE_HISTORIES_READ = 'non_census_covered_life_histories_read';
export const NON_CENSUS_COVERED_LIFE_HISTORY_READ = 'non_census_covered_life_history_read';
export const PATIENT_PRACTICE_CREATE = 'patient_practice_create';
export const PATIENT_PRACTICE_DELETE = 'patient_practice_delete';
export const PATIENT_PRACTICE_LOCATION_CREATE = 'patient_practice_location_create';
export const PATIENT_PRACTICE_LOCATION_DELETE = 'patient_practice_location_delete';
export const PATIENT_PRACTICE_LOCATION_READ = 'patient_practice_location_read';
export const PATIENT_PRACTICE_LOCATION_UPDATE = 'patient_practice_location_update';
export const PATIENT_PRACTICE_LOCATIONS_READ = 'patient_practice_locations_read';
export const PATIENT_PRACTICE_READ = 'patient_practice_read';
export const PATIENT_PRACTICE_UPDATE = 'patient_practice_update';
export const PATIENT_PRACTICES_READ = 'patient_practices_read';
export const PROVIDER_PAY_PAYER_RATE_CARD_CREATE = 'provider_pay_payer_rate_card_create';
export const PROVIDER_PAY_PAYER_RATE_CARD_READ = 'provider_pay_payer_rate_card_read';
export const PROVIDER_PAY_PAYER_RATE_CARD_UPDATE = 'provider_pay_payer_rate_card_update';
export const PROVIDER_PAY_PAYER_RATE_CARDS_READ = 'provider_pay_payer_rate_cards_read';
export const QUESTIONNAIRE_OFFSHORE_READ = 'questionnaire_offshore_read';
export const QUESTIONNAIRE_READ = 'questionnaire_read';
export const QUESTIONNAIRE_REPORT_READ = 'questionnaire_report_read';
export const QUESTIONNAIRES_OFFSHORE_READ = 'questionnaires_offshore_read';
export const QUESTIONNAIRES_READ = 'questionnaires_read';
export const REGION_ARCHIVE = 'region_archive';
export const REGION_CREATE = 'region_create';
export const REGION_READ = 'region_read';
export const REGIONS_READ = 'regions_read';
export const REGISTRATION_COVERED_LIVES_LOOKUP = 'registration_covered_lives_lookup';
export const REPLACEMENT_SESSION_APPROVE = 'replacement_session_approve';
export const REPORTING_INTEGRATION_RUN_UPDATE = 'reporting_integration_run_update';
export const SSO_CLIENT_CREATE = 'sso_client_create';
export const SSO_CLIENT_READ = 'sso_client_read';
export const SSO_CLIENT_UPDATE = 'sso_client_update';
export const SSO_CLIENTS_READ = 'sso_clients_read';
export const TASKS_READ = 'tasks_read';
export const TRIAL_CREATE = 'trial_create';
export const TRIAL_DELETE = 'trial_delete';
export const TRIAL_OFFSHORE_READ = 'trial_offshore_read';
export const TRIAL_READ = 'trial_read';
export const TRIAL_UPDATE = 'trial_update';
export const TRIALS_OFFSHORE_READ = 'trials_offshore_read';
export const TRIALS_READ = 'trials_read';
export const USER_CARE_PROVIDER_MFA_DELETE = 'user_care_provider_mfa_delete';
export const USER_CREATE = 'user_create';
export const USER_CREATE_ADMIN = 'user_create_admin';
export const USER_CREATE_AUTH = 'user_create_auth';
export const USER_DELETE = 'user_delete';
export const USER_MEMBER_MFA_DELETE = 'user_member_mfa_delete';
export const USER_MFA_DELETE = 'user_mfa_delete';
export const USER_OFFSHORE_READ = 'user_offshore_read';
export const USER_OFFSHORE_REVOKE_TOKENS = 'user_offshore_revoke_tokens';
export const USER_OFFSHORE_UPDATE = 'user_offshore_update';
export const USER_READ = 'user_read';
export const USER_REVOKE_TOKENS = 'user_revoke_tokens';
export const USER_ROLES_ADD = 'user_roles_add';
export const USER_ROLES_DELETE = 'user_roles_delete';
export const USER_ROLES_READ = 'user_roles_read';
export const USER_ROLES_UPDATE = 'user_roles_update';
export const USER_SSO_PROVIDER_DELETE = 'user_sso_provider_delete';
export const USER_UPDATE = 'user_update';
export const USERS_LIST = 'users_list';
export const USERS_OFFSHORE_READ = 'users_offshore_read';
export const USERS_READ = 'users_read';
export const USERS_SHOW = 'users_show';
export const VERSIONS_READ = 'versions_read';
export const WORKDAY_EVENT_CREATE = 'workday_event_create';
export const WORKPLACE_CUSTOMIZATION_CREATE = 'workplace_customization_create';
export const WORKPLACE_CUSTOMIZATION_OFFSHORE_READ = 'workplace_customization_offshore_read';
export const WORKPLACE_CUSTOMIZATION_READ = 'workplace_customization_read';
export const WORKPLACE_CUSTOMIZATION_UPDATE = 'workplace_customization_update';
export const WPO_CONFIG_READ = 'wpo_config_read';
export const WPO_CUSTOMER_CONFIG_UPDATE = 'wpo_customer_config_update';
export const WPO_REGION_POLICY_UPDATE = 'wpo_region_policy_update';
